import { Directive, HostListener, input, inject } from '@angular/core';
import { GtagService } from '../services/gtag.service';

@Directive({
  selector: '[trackLinkClick]',
  standalone: true,
})
export class TrackLinkClickDirective {
  private gtagService = inject(GtagService);

  // The URL to track (e.g., 'mailto:test@example.com', '/about', 'tel:123456')
  trackLinkClick = input.required<string>();

  // Optional context to identify where the click came from (e.g., 'footer-email', 'topbar-menu-Contact')
  trackContext = input<string>('');

  @HostListener('click')
  onClick(): void {
    const url = this.trackLinkClick();
    const context = this.trackContext();

    if (url) {
      this.gtagService.urlCheck(url, context);
    }
  }
}
